import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PilotPayHttpClient } from '../../core';
import { IJobTitle, JobTitle } from './job-titles.types';
/**
 * JobTitlesService
 */
@Injectable()
export class JobTitlesService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public getJobTitles(): Observable<IJobTitle[]> {
		return this.http.getRequest('/api/job-titles');
	}

	public getArchivedJobTitles(): Observable<IJobTitle[]> {
		return this.http.getRequest('/api/job-titles/archived');
	}

	public getJobTitleById(id: string): Observable<IJobTitle> {
		return this.http.getRequest(`/api/job-titles/${id}`);
	}

	public getArchivedJobTitleById(id: string): Observable<IJobTitle> {
		return this.http.getRequest(`/api/job-titles/archived/${id}`);
	}

	public addJobTitle(job: IJobTitle): Observable<JobTitle> {
		return this.http.postRequest('/api/job-titles', job);
	}

	public deleteJobTitle(id: string, endDate: string): Observable<any> {
		return this.http.deleteRequest(`/api/job-titles/${id}/${endDate}`);
	}

	public updateJobTitle(job: IJobTitle): Observable<JobTitle> {
		return this.http.putRequest(`/api/job-titles`, job);
	}
}
